<ng-container *ngIf="modulePermitted; else moduleNotPermitted">
    <h6 class="bxt-table-title">{{ title }} ({{ page.totalElements }})</h6>

    <bx-table-header
        (createNew)="newContact()"
        [createNewEnabled]="!deletedView"
        [showCreateNew]="permissionService.isAvailable('contacts.maintain-contacts.add-contact')"
        (searchEvent)="setSearch($event)"
        [searchable]="true"
        [moreActions]="moreActions"
        [moreActionsDisabled]="deletedView"
        (moreActionEvent)="resolveAction($event)"
        [showSettingsActions]="true">
        <app-bx-dropdown-generic settings #dropdown [buttonLabel]="'Settings'" [placement]="'right'" [insideClick]="true">
            <div class="group-start">
                <app-bx-dropdown-options [groups]="settingsActions" [type]="'radio'" (select)="resolveSettingsAction($event)">
                </app-bx-dropdown-options>
            </div>

            <div class="group-end">
                <app-bx-dropdown-options
                    [groups]="simpleItems"
                    [type]="'simple'"
                    (select)="resolveSimpleItemsSettingsAction($event); dropdown.close()">
                </app-bx-dropdown-options>
            </div>
        </app-bx-dropdown-generic>
    </bx-table-header>

    <div class="col-xs-12 text-center empty-table" *ngIf="rows?.length === 0 && !isLoading">
        <h4 class="margin-top-30 margin-bottom-30" *ngIf="!deletedView">
            You don't have any contacts here yet.<br />
            Click the 'Create new' button above to get started, or you can
            <a
                [ngClass]="{ 'btn-disabled': !permissionService.isAvailable('contacts.maintain-contacts.import-from-excel') }"
                (click)="showImportExcelModal()"
                >import from Excel</a
            >
        </h4>
        <h4 class="margin-top-30 margin-bottom-30" *ngIf="deletedView">You don't have any deleted contacts</h4>
    </div>

    <div class="table-wrapper" #tableWrapper>
        <ngx-datatable
            [ngStyle]="{ height: tableHeight }"
            #myTable
            *ngIf="rows.length > 0"
            class="material bxt-table"
            [rowHeight]="40"
            [rows]="rows"
            [columnMode]="'force'"
            [headerHeight]="50"
            [loadingIndicator]="isLoading"
            [footerHeight]="50"
            [externalPaging]="true"
            [count]="page.totalElements"
            [offset]="page.pageNumber"
            [limit]="page.size"
            (page)="setPage($event)"
            [externalSorting]="true"
            (sort)="onSort($event)"
            [rowClass]="getRowClass"
            [scrollbarV]="true"
            [scrollbarH]="layoutService.isMobile()"
            [virtualization]="false"
            [sorts]="[{ prop: sortField, dir: 'asc' }]"
            (resize)="onResize($event)">
            <!-- columns  -->
            <ngx-datatable-column
                name="Contact Name"
                prop="Name"
                [cellClass]="'show-pipe'"
                [headerClass]="'show-pipe'"
                [width]="contactsWidths.Name">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        *ngIf="
                            permissionService.isAvailable('contacts.maintain-contacts.contact-details') && !row.IsDeleted;
                            else disabledDesc
                        "
                        class="bxt-row-action"
                        title="{{ row.Name }}"
                        [routerLink]="['/contacts', 'list', row.ID_Contact]">
                        {{ row.Name }}</a
                    >
                    <ng-template #disabledDesc>{{ row.Name }}</ng-template>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Business Name" prop="BusinessName" [width]="contactsWidths.BusinessName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                        *ngIf="
                            permissionService.isAvailable('contacts.maintain-contacts.contact-details') && !row.IsDeleted;
                            else disabledDesc
                        "
                        class="bxt-row-action"
                        title="{{ row.BusinessName }}"
                        [routerLink]="['/contacts', 'list', row.ID_Contact]">
                        {{ row.BusinessName }}</a
                    >
                    <ng-template #disabledDesc>{{ row.BusinessName }}</ng-template>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Type" prop="ContactType" [width]="contactsWidths.ContactType">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.ContactType }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Card Status" prop="CardExpiryNext" [cellClass]="'status'" [width]="contactsWidths.CardExpiryNext">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span
                        *ngIf="row.CardStatus"
                        class="label"
                        [ngClass]="{
                            'label-danger': row.CardStatus === 'Expired',
                            'label-warning': row.CardStatus === 'Expiring',
                            'label-success': row.CardStatus === 'Valid',
                        }"
                        >{{ row.CardStatus }} {{ row.CardStatus !== 'Valid' ? row.CardExpiryNextFriendly : '' }}</span
                    >
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Work Phone" prop="WorkPhone" [width]="contactsWidths.WorkPhone">
                <ng-template ngx-datatable-cell-template let-value="value">
                    {{ value | phoneNumberLocalize }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="{{ 'general.address.mobile' | translate }}" prop="Mobile" [width]="contactsWidths.Mobile">
                <ng-template ngx-datatable-cell-template let-value="value">
                    {{ value | phoneNumberLocalize }}
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Email" prop="Email" [width]="contactsWidths.Email"></ngx-datatable-column>
            <ngx-datatable-column *ngIf="deletedView" [sortable]="false" name="Deleted Date" prop="DateDeleted" [headerClass]="'disabled'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    {{ row.DateDeleted | date: 'mediumDate' }}
                </ng-template>
            </ngx-datatable-column>

            <!-- Call to action list-->
            <ngx-datatable-column
                [width]="165"
                [sortable]="false"
                [canAutoResize]="false"
                [draggable]="false"
                [resizeable]="false"
                [cellClass]="'right-align'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div *ngIf="!row.IsDeleted">
                        <button
                            type="button"
                            class="btn btn-sm btn-default btn-default--narrow margin-right-2"
                            *ngIf="canSetReminders"
                            (click)="addReminder(row)">
                            <i class="ti-alarm-clock"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-default btn-default--narrow margin-right-1"
                            *ngIf="canSendEmail"
                            (click)="emailContact(row)">
                            <i class="ti-email"></i>
                        </button>
                        <button
                            *ngIf="canSendSms"
                            type="button"
                            class="btn btn-sm btn-default btn-default--narrow margin-right-1"
                            (click)="smsContact(row)">
                            <i class="ti-mobile"></i>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-danger btn-default--narrow"
                            *ngIf="permissionService.isAvailable('contacts.maintain-contacts.delete-contact')"
                            (click)="deleteContact(row)"
                            [disabled]="row.InternalUserId"
                            [matTooltip]="'This contact is linked to an internal user and cannot be deleted'"
                            [matTooltipDisabled]="!row.InternalUserId">
                            <i class="ti-trash"></i>
                        </button>
                    </div>
                    <div *ngIf="row.IsDeleted">
                        <button
                            type="button"
                            class="btn btn-sm btn-default"
                            (click)="recoveryContact(row)"
                            title="Recovery"
                            *ngIf="permissionService.isAvailable('recycle-bin.recover-data.recycle-bin-access')">
                            <i class="ti-reload"></i>
                        </button>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-footer>
                <ng-template
                    ngx-datatable-footer-template
                    let-rowCount="rowCount"
                    let-pageSize="pageSize"
                    let-selectedCount="selectedCount"
                    let-curPage="curPage"
                    let-offset="offset"
                    let-isVisible="isVisible">
                    <app-table-footer-paging *ngIf="rowCount > 10" [size]="page.size" (pageLimitChange)="pageLimit($event)">
                    </app-table-footer-paging>

                    <datatable-pager
                        [pagerLeftArrowIcon]="'datatable-icon-left'"
                        [pagerRightArrowIcon]="'datatable-icon-right'"
                        [pagerPreviousIcon]="'datatable-icon-prev'"
                        [pagerNextIcon]="'datatable-icon-skip'"
                        [page]="curPage"
                        [size]="pageSize"
                        [count]="rowCount"
                        [hidden]="!(rowCount / pageSize > 1)"
                        (change)="table.onFooterPage($event)">
                    </datatable-pager>
                </ng-template>
            </ngx-datatable-footer>
        </ngx-datatable>
    </div>

    <div class="row">
        <help-note-wrapper
            title="The difference between Contacts and Clients "
            class="col-sm-12"
            url="https://help.buildxact.com/en/?q=contacts"
            footer="Read more in our FAQ’s"
            setting="NoteContactList"
            *ngIf="!deletedView"
            [expanded]="true">
            Here is where you can add details for any supplier, trade, contractor or company you work with. You can then keep track of any
            documents you send to them such as certificates or licenses, as well as any communications, price catalogues, notes or reminders
            you send to them.
            <br /><br />
            If you want to manage your customers that have come through from Leads or Estimates, use the Clients section.
        </help-note-wrapper>
    </div>
</ng-container>
<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
